import { BehaviorSubject, Observable, } from "rxjs";
export var rxWebSocket = function (url, input) {
    var connectionStatus$ = new BehaviorSubject(0);
    var command$ = new Observable(function (observer) {
        var socket = new WebSocket(url);
        socket.binaryType = "arraybuffer";
        var inputSubscription;
        var open = false;
        var closed = function () {
            if (!open) {
                return;
            }
            connectionStatus$.next(connectionStatus$.getValue() - 1);
            open = false;
        };
        socket.onopen = function () {
            open = true;
            connectionStatus$.next(connectionStatus$.getValue() + 1);
            inputSubscription = input.subscribe(function (data) {
                socket.send(data);
            });
        };
        socket.onmessage = function (message) {
            observer.next(message.data);
        };
        socket.onerror = function (error) {
            closed();
            observer.error(error);
        };
        socket.onclose = function (event) {
            closed();
            if (event.wasClean) {
                observer.complete();
            }
            else {
                observer.error(new Error(event.reason));
            }
        };
        return function () {
            if (inputSubscription) {
                inputSubscription.unsubscribe();
            }
            if (socket) {
                closed();
                socket.close();
            }
        };
    });
    return { receive$: command$, connectionStatus$: connectionStatus$ };
};



//////////////////
// WEBPACK FOOTER
// ./src/utils/network/rxWebSocket.ts
// module id = 2997
// module chunks = 3